import { Facility } from './facilities.model';

export interface EventSlot {
    displayTime: string;
    facility?: Facility | null;
}

export interface EventDetail {
    id: number;
    uuid: string;
    name: string;
    description?: string;
    startDateTs?: number;
    endDateTs?: number;
    hasSlots: boolean;
    slots?: EventSlot[];
}

export type AllocationStatus = 'cancelled' | 'checkedIn' | 'confirmed' | 'pending';

const ALLOCATION_STATUSES: readonly AllocationStatus[] = [
    'cancelled',
    'checkedIn',
    'confirmed',
    'pending',
];

/**
 * Normalises a raw allocation status from the API into an {@link AllocationStatus}.
 *
 * The API serialises multi-word statuses in snake/kebab case (e.g. `checked_in`),
 * and humps only camelises object *keys*, not string *values* — so the raw value
 * never matches our camelCase union. This converts the separators and validates
 * against the known set, returning `null` for anything unrecognised.
 */
export function normaliseAllocationStatus(raw: string | null | undefined): AllocationStatus | null {
    if (!raw) return null;
    const camel = raw.replace(/[-_]+(\w)/g, (_, c: string) => c.toUpperCase());
    return (ALLOCATION_STATUSES as readonly string[]).includes(camel)
        ? (camel as AllocationStatus)
        : null;
}

export interface EventAllocation {
    uuid: string;
    checkinAt: string | null;
    fulfilledAt: string | null;
    paidAt: string | null;
    cancelledAt: string | null;
    status: AllocationStatus;
    profileName: string | null;
    profilePackageId: number | null;
    packageName: string | null;
    displayName: string | null;
    customerId: number | null;
}

export interface UpcomingEventPackageSummary {
    packageId: number | null;
    packageName: string;
    count: number;
}

export interface UpcomingEvent {
    id: number;
    uuid: string;
    name: string;
    startDateTs?: number;
    endDateTs?: number;
    totalTickets: number;
    packageSummary: UpcomingEventPackageSummary[];
}
